module.exports = __webpack_public_path__ + "img/1457739921.d8fdb0ec.jpg";